var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",class:{ open: _vm.open }},[_c('span',{staticClass:"bit-1"}),_c('span',{staticClass:"bit-2"}),_c('span',{staticClass:"bit-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }